'use strict';
import * as $j_app$002edata$002e$002dDrug$002dDescription$0024 from "./app.data.-Drug-Description$.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_DrugRequestData$$anon$4() {
}
export { $c_Lapp_api_DrugRequestData$$anon$4 as $c_Lapp_api_DrugRequestData$$anon$4 };
$c_Lapp_api_DrugRequestData$$anon$4.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_DrugRequestData$$anon$4.prototype.constructor = $c_Lapp_api_DrugRequestData$$anon$4;
/** @constructor */
function $h_Lapp_api_DrugRequestData$$anon$4() {
}
export { $h_Lapp_api_DrugRequestData$$anon$4 as $h_Lapp_api_DrugRequestData$$anon$4 };
$h_Lapp_api_DrugRequestData$$anon$4.prototype = $c_Lapp_api_DrugRequestData$$anon$4.prototype;
$c_Lapp_api_DrugRequestData$$anon$4.prototype.toString__T = (function() {
  return "<function0>";
});
$c_Lapp_api_DrugRequestData$$anon$4.prototype.apply__O = (function() {
  return $j_app$002edata$002e$002dDrug$002dDescription$0024.$m_Lapp_data_DrugDescription$().derived$Schema__Lsttp_tapir_Schema();
});
var $d_Lapp_api_DrugRequestData$$anon$4 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_DrugRequestData$$anon$4, "app.api.DrugRequestData$$anon$4", ({
  Lapp_api_DrugRequestData$$anon$4: 1,
  F0: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction0: 1
}));
export { $d_Lapp_api_DrugRequestData$$anon$4 as $d_Lapp_api_DrugRequestData$$anon$4 };
//# sourceMappingURL=app.api.-Drug-Request-Data$$anon$4.js.map
